import React, { useState } from 'react';
import "react-datetime/css/react-datetime.css";
import Datetime from "react-datetime";
import moment from 'moment';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Modal from 'react-bootstrap/Modal';
import Badge from 'react-bootstrap/Badge';

function ScheduleNavbarDropdown(props) {
  const [calendarItemSelected, setCalendarItemSelected] = useState(false);
  var onScheduleTypeChange = function(event){
    console.log(event.target.name)
 //   setSelectedItem(newschedule);
   props.onScheduleTypeChange(event.target.name)
   if(event.target.name==='SELECT')
    setCalendarItemSelected(false)
  }
  var handleScheduledFilterChangeCalendar = function(event){
    props.onScheduleTypeChange(event.toDate())
   setCalendarItemSelected(true)
  }
  var unscheduledLabel=props.unscheduledItems.length>0?"Unscheduled ("+props.unscheduledItems.length+")" :"Unscheduled";
  var title="Today"
  if(props.currentSchedule==="ALL"){
    title="All"
  }else if(props.currentSchedule==="NOT_SCHEDULED"){
    title=unscheduledLabel
  }else if(props.currentSchedule==="TODAY"){
    title="Today"
    if(props.unscheduledItems.length>0){
      //title=title+" (*)";
    }
  }else{
    if(props.currentSchedule!=="SELECT")
     title=moment(props.currentSchedule).format('Do MMM')
  }
  return (
<>
    <NavDropdown expand="lg" title={title} id="selected-schedule">
      <NavDropdown.Item name="TODAY" onClick={onScheduleTypeChange}>Today </NavDropdown.Item>
      <NavDropdown.Item name="ALL" onClick={onScheduleTypeChange}>All</NavDropdown.Item>
      <NavDropdown.Item  name="NOT_SCHEDULED" onClick={onScheduleTypeChange}>Unscheduled {props.unscheduledItems.length>0 && <Badge bg="secondary">{props.unscheduledItems.length}</Badge>}</NavDropdown.Item>
      <NavDropdown.Item name="SELECT" onClick={onScheduleTypeChange}>Select from List</NavDropdown.Item>
    </NavDropdown>
    {!calendarItemSelected && props.currentSchedule!=='TODAY' && props.currentSchedule!=='ALL' && props.currentSchedule!=='NOT_SCHEDULED' && 
    <Modal show={true} backdrop="static"  keyboard={false} centered>
    
    <Modal.Header closeButton>
          <Modal.Title>Select Date</Modal.Title>
        </Modal.Header>

        <Modal.Body>
        <Datetime open={true} dateFormat="DD-MMM-YYYY" timeFormat={false}  closeOnSelect={true} value={moment(props.currentSchedule)}  onChange={handleScheduledFilterChangeCalendar} />
        </Modal.Body>

      
  
      </Modal> 
}
</>
  );
}
export default ScheduleNavbarDropdown